"use client";

import type React from "react";

import { useState } from "react";
import { Button } from "@papier/ui/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@papier/ui/components/ui/dialog";
import { Eye } from "lucide-react";
import { SchemaField } from "@papier/grapesjs-editor/src/components/editor/schema-builder/types/schema";
import { SchemaCanvas } from "./schema-canvas";

interface SchemaViewerDialogProps {
  trigger?: React.ReactNode;
  schema: SchemaField[];
  title?: string;
  onFieldSelect?: (field: SchemaField) => void;
  selectedField?: SchemaField | null;
}

export function SchemaViewerDialog({
  trigger,
  schema,
  title = "Schema Viewer",
  onFieldSelect,
  selectedField,
}: SchemaViewerDialogProps) {
  const [open, setOpen] = useState(false);

  const handleFieldSelect = (field: SchemaField) => {
    if (onFieldSelect) {
      onFieldSelect(field);
      setOpen(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || (
          <Button variant="outline">
            <Eye className="mr-2 h-4 w-4" />
            View Schema
          </Button>
        )}
      </DialogTrigger>
      <DialogContent className="max-h-[80vh] max-w-4xl overflow-hidden">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>

        <div className="max-h-[70vh] overflow-y-auto p-6">
          <SchemaCanvas
            schema={schema}
            selectedField={selectedField}
            readOnly={true}
            onFieldSelect={onFieldSelect ? handleFieldSelect : undefined}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
